import { Tooltip } from '@material-ui/core';
import React from 'react';

import { isPublica } from '~/src/dash/resellers/utils/importResellerConfig';

const DEFAULT_ACTIVE_TEXT_COLOR = isPublica() ? '#60c7bc' : '#ad0509';
const DEFAULT_ACTIVE_BACKGROUND_COLOR = isPublica() ? '#edfffd' : '#fcebeb';

export interface IPillItem {
  text: string;
  activeTextColor?: string;
  activeBackgroundColor?: string;
  icon?: IPillItemIcons;
}

interface IPillItemIcons {
  active: string | JSX.Element;
  inactive: string | JSX.Element;
}

interface ICustomStyleProp {
  [key: string]: any;
}

interface IPillSwitcherProps {
  // The text options to display
  pills: IPillItem[];
  disabled?: boolean;
  currentText: string;
  defaultBackgroundColor?: string;
  onChange?: (value: string) => void;
  customStyle?: ICustomStyleProp;
  tooltip?: string;
}

type FlexDirectionType =
  | '-moz-initial'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'unset'
  | 'column'
  | 'column-reverse'
  | 'row'
  | 'row-reverse'
  | undefined;

const PillSwitcher = ({
  pills,
  disabled,
  currentText,
  onChange,
  defaultBackgroundColor,
  tooltip = '',
  customStyle,
}: IPillSwitcherProps) => {
  // There needs to be at least 2 options otherwise
  // there's no point in using the PillSwitcher
  if (pills.length <= 1) {
    return null;
  }

  const PILL_WIDTH = 70;
  const PILL_HEIGHT = 30;

  return (
    <Tooltip title={tooltip}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row' as FlexDirectionType, // Needed for typescript :/
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '10px',
          backgroundColor: defaultBackgroundColor || '#f9f9f9',
          borderRadius: '11px',
          maxWidth:
            '' +
            pills.length *
              (customStyle ? (customStyle.width ? customStyle.width : PILL_WIDTH) : PILL_WIDTH) +
            'px',
        }}
      >
        {pills.map((pillItem) => {
          const pillIcon =
            pillItem.icon &&
            (currentText === pillItem.text ? pillItem.icon.active : pillItem.icon?.inactive);
          const activeTextColor = pillItem.activeTextColor || DEFAULT_ACTIVE_TEXT_COLOR;
          const activeBackgroundColor =
            pillItem.activeBackgroundColor || DEFAULT_ACTIVE_BACKGROUND_COLOR;

          return (
            <div
              style={{
                textAlign: 'center',
                padding: '5px',
                borderRadius: '11px',
                width: PILL_WIDTH + 'px',
                height: PILL_HEIGHT + 'px',
                color: currentText === pillItem.text ? activeTextColor : '#3b3b3b',
                backgroundColor:
                  currentText === pillItem.text
                    ? activeBackgroundColor
                    : defaultBackgroundColor || '#f9f9f9',
                boxShadow: currentText === pillItem.text ? '0px 3px 4px #e9f5f4' : '',
                fontSize: '14px',
                // @ts-ignore
                fontWeight: currentText === pillItem.text ? 500 : 400,
                cursor: disabled ? 'not-allowed' : 'pointer',
                ...customStyle,
              }}
              onClick={() => {
                if (!disabled && onChange) {
                  onChange(pillItem.text);
                }
              }}
            >
              {(pillItem.icon && typeof pillIcon === 'string' && (
                <img
                  style={{ paddingRight: 5, verticalAlign: 'text-bottom' }}
                  src={pillIcon as string}
                />
              )) ||
                (typeof pillIcon === 'object' && pillIcon)}
              {pillItem.text}
            </div>
          );
        })}
      </div>
    </Tooltip>
  );
};

export default PillSwitcher;
